import React from 'react';
import PropTypes from 'prop-types';

import './style.css';

function ActionModal({ open, onClose, className, style, children }) {
  if (!open) return null;
  return (
    <div className={`action-modal ${className || ''}`} style={style} onClick={onClose}>
      {children}
    </div>
  );
}

ActionModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.object
};

export default ActionModal;
